import { HttpClient } from './http-client';
import * as CONST_URL from './common-url';


export const HomeService = {
  getHomePageCharts: (userId) => {
    return HttpClient.get(CONST_URL.B2b_EXT(), {
      output: 'json',
      section: 'home_page',
      action: 'init',
      external_table: 'royalty_statement',
      external_user_id: userId,
      period_report_limit: 24,
      latest_statements_limit: 4,
      top_releases_report_limit: 4,
      top_tracks_report_limit: 9,
      number_format: 'en_en'
    });
  },
  getFilteredChannelCharts: (userId, report_key) => {
    return HttpClient.get(CONST_URL.B2b_EXT(), {
      output: 'json',
      section: 'base',
      action: 'royalty_period_report_app',
      external_table: 'royalty_statement',
      external_user_id: userId,
      report_type: 'channel',
      report_key: report_key,
      number_format: 'en_en',

    });
  },



}